<template>
  <div class="modal-overlay">
    <div class="modal-content" style="max-width: 97vw; min-height: 65vh">
      <div class="modal-header">
        <h5 class="modal-title">Add Stock Manually</h5>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>

      <div class="modal-body">
        <!-- <div style="margin-bottom: 1rem">
          <label>Supplier:</label>
          <input
            v-model="supplier"
            type="text"
            class="form-control"
            placeholder="Enter Supplier Name"
          />
        </div> -->

        <div class="mb-3">
          <label for="exampleSelect" class="form-label">Select Item</label>
          <select v-model="supplier" class="form-select" id="exampleSelect">
            <option disabled value="">-- Select --</option>
            <option
              v-for="supplier in suppliers"
              :key="supplier.id"
              :value="supplier.id"
            >
              {{ supplier.supplier_name }}
            </option>
          </select>
        </div>

        <table class="table table-bordered">
          <thead>
            <tr>
              <th width="35%">Item</th>
              <th width="5%">Purchase Price</th>
              <th width="5%">Sale Price</th>
              <th width="10%">Batch Number</th>
              <th width="15%">Expiry Date</th>
              <th width="15%">Inward Date</th>
              <th width="5%">Quantity</th>
              <th width="10%">Action</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="row in rows" :key="row.id">
              <td width="15%">
                <ItemInput
                  @itemoption-check="takeItem"
                  :Rowid="row.id"
                  :Store_id="origin_store_id"
                  :type="'items'"
                />
              </td>

              <td>
                <input
                  v-model.number="row.purchase_price"
                  type="number"
                  class="form-control"
                />
              </td>
              <td>
                <input
                  v-model.number="row.sale_price"
                  type="number"
                  class="form-control"
                />
              </td>
              <td>
                <input
                  v-model="row.batch_number"
                  type="text"
                  class="form-control"
                />
              </td>
              <td>
                <input
                  v-model="row.expiry_date"
                  type="date"
                  class="form-control"
                />
              </td>
              <td>
                <input
                  v-model="row.inward_date"
                  type="date"
                  class="form-control"
                />
              </td>
              <td>
                <input
                  v-model.number="row.quantity"
                  type="number"
                  min="1"
                  class="form-control"
                />
              </td>
              <td>
                <button
                  @click="removeRow(row.id)"
                  type="button"
                  class="btn btn-danger btn-sm"
                >
                  --
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <button @click="addRow" class="btn btn-secondary btn-sm">
          + Add Item
        </button>
      </div>

      <div class="modal-footer">
        <button @click="submitForm" class="btn btn-primary">Submit</button>
      </div>
    </div>
  </div>
</template>

<script>
import ItemInput from "../../Inventory/components/iteminput.vue";
import { generalApiRequest } from "../../../api/apiIndex";

export default {
  name: "AddStockManuallyModal",
  components: { ItemInput },

  data() {
    return {
      supplier: "",
      suppliers: [],
      origin_store_id: this.$route.params.storeLocation,
      currentDate: new Date().toISOString().substr(0, 10),
      rows: [
        {
          id: 1,
          item_id: "",
          purchase_price: 0,
          sale_price: 0,
          batch_number: "",
          expiry_date: "",
          inward_date: new Date().toISOString().substr(0, 10),
          quantity: 1,
        },
      ],
    };
  },

  methods: {
    addRow() {
      const newRow = {
        id: Math.floor(Math.random() * 100000),
        item_id: "",
        purchase_price: 0,
        sale_price: 0,
        batch_number: "",
        expiry_date: "",
        inward_date: this.currentDate,
        quantity: 1,
      };
      this.rows.push(newRow);
    },

    removeRow(id) {
      this.rows = this.rows.filter((row) => row.id !== id);
    },

    takeItem(item, rowId) {
      const targetRow = this.rows.find((r) => r.id === rowId);
      if (targetRow) {
        targetRow.item_id = item.id;
      }
    },

    async getSuppliers() {
      const url = "get_suppliers_unpaginated";
      const res = await generalApiRequest(url, "GET", {}, 1);
      this.suppliers = res.data;
    },

    async submitForm() {
      const payload = {
        supplier: this.supplier,
        origin_store_id: this.origin_store_id,
        items: this.rows.map((row) => ({
          item_id: row.item_id,
          purchase_price: row.purchase_price,
          sale_price: row.sale_price,
          batch_number: row.batch_number,
          expiry_date: row.expiry_date,
          inward_date: row.inward_date,
          quantity: row.quantity,
        })),
      };

      console.log(payload); // or trigger your API call here
      const url = "inventory/bulk-add-stock";
      const res = await generalApiRequest(url, "POST", payload, 1);

      if (res.status === "success") {
        this.closeModal();
        location.reload();
      } else {
        alert("Failed to submit stock.");
      }
    },

    closeModal() {
      this.$emit("close-add-stock-manually-modal");
    },
  },
  mounted() {
    this.getSuppliers();
  },
};
</script>

<style scoped>
.modal-body {
  padding: 1rem;
  overflow-y: auto;
  flex-grow: 1;
}

.modal-footer {
  border-top: 1px solid #ddd;
  display: flex;
  justify-content: flex-end;
  padding-top: 1rem;
}

.close {
  background: rgb(233, 22, 22);
  border: none;
  font-size: 1.5rem;
  color: white;
  cursor: pointer;
}

table th,
table td {
  vertical-align: middle;
  /* text-align: center; */
}

.btn-sm {
  padding: 0.3rem 0.6rem;
}
</style>
